module.exports = __webpack_public_path__ + "img/icon_audit.4e9cb303.png";